import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'gbc-tile-footer',
    templateUrl: './tile-footer.component.html',
    styleUrls: ['./tile-footer.component.scss'],
    standalone: true
})
export class TileFooterComponent {
}
